import { render, staticRenderFns } from "./byForm.vue?vue&type=template&id=c63f4ae6&scoped=true"
import script from "./byForm.vue?vue&type=script&lang=js"
export * from "./byForm.vue?vue&type=script&lang=js"
import style0 from "./byForm.vue?vue&type=style&index=0&id=c63f4ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f4ae6",
  null
  
)

export default component.exports